(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'LivePlannerParticipant',
	};

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		// nothing to do here for now
	};

	form.success = function success(response)
	{
		var $modal    = $('.modal');
		var client_id = null;
		var label     = '<b>Client: </b>';

		if (Adzuki.Form.hasError(response)) {
			return false;
		}

		client_id = response['data']['client_id'];
		label     += response['data']['first_name'] + ' ' + response['data']['last_name'];
		label     += ' - ' + response['data']['email'];

		_addParticipant(client_id, label);

		// client added, close the modal
		Adzuki.StatusMessage('success', 'Participant saved successfully');
		$modal.modal('hide');
	};

	function _addParticipant(client_id, label)
	{
		var $recipient_search    = $('.recipient-selection').first();
		var $recipient_template  = $recipient_search.find('.recipient.template').first();
		var $selected_recipients = $recipient_search.find('.selected-recipients').first();
		var $recipient           = $recipient_template.clone();
		var form_name            = 'form_component_data[LivePlannerAppointment][recipient]';

		$recipient.removeClass('template');
		$recipient.find('input').val(client_id).attr('name', form_name + '[client][]');
		$recipient.find('.title').html(label);
		$recipient.addClass('client ' + client_id);
		$recipient.appendTo($selected_recipients.find('.recipients'));

		if ($selected_recipients.hasClass('hidden')) {
			$selected_recipients.removeClass('hidden');
		}
	}
}(jQuery, window.Adzuki || {}));
